import { encrypt, decrypt } from './crypto';

const getItem = (key) => {
  const plainText = localStorage.getItem(key);
  return decrypt(plainText);
};

const setItem = (key, value) => {
  localStorage.setItem(
    key,
    value != null || value != undefined ? encrypt(value) : '',
  );
};

export default {
  getItem,
  setItem,
};
